<template>
  <div class="redirecting"></div>
</template>

<script>
export default {
  name: "Recharge",
  mounted() {
    this.$router.replace({ path: "/CzContent" });
  }
};
</script>

<style scoped>
.redirecting {
  min-height: 100%;
  background: #f4f7fb;
}
</style>

